export default __webpack_public_path__ + "static/media/rekananTeknisiAvatar.a5351d67.png";